import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BatchSourcingDefaultService {

	url = {
		saveSourcingData : '/saveJsonObject?action_code=pq78v0'
	}
  	durationInSeconds= 5;

  	constructor(private httpClient: HttpClient, private http:HttpClient, private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService) { }

	saveSourcingInfoData(baseURL: string, jsonData: any, baseGlobalParams: any, checkLockedObj: any, selectedMeCodes: any) {
		const url = `${baseURL}${this.url.saveSourcingData}`;
		const options = { withCredentials: true };

		const meCodes = (Array.isArray(selectedMeCodes) ? selectedMeCodes : String(selectedMeCodes ?? '').split(','))
			.map((c) => String(c).trim())
			.filter((c) => c !== '');
		const meCodeStr = [...new Set(meCodes)].join(',');

		let lockPayload: any[] = [];
		if (typeof checkLockedObj === 'string') {
			try {
				const parsed = JSON.parse(checkLockedObj);
				lockPayload = Array.isArray(parsed) ? parsed : [parsed];
			} catch {
				lockPayload = [];
			}
		} else if (Array.isArray(checkLockedObj)) {
			lockPayload = checkLockedObj;
		} else if (checkLockedObj && typeof checkLockedObj === 'object') {
			lockPayload = [checkLockedObj];
		}

		const data: Record<string, string> = {
			tax_year: String(jsonData.TAX_YEAR ?? ''),
			scenario: String(jsonData.SCENARIO ?? ''),
			jcd_key: String(jsonData.JCD_KEY ?? ''),
			sso_id: String(jsonData.SSO_ID ?? ''),
			is_issue_key_enabled: String(baseGlobalParams?.is_issue_key_enabled ?? 'N'),
			clob_settings: JSON.stringify([jsonData]),
			clob_data: JSON.stringify({ me_code: meCodeStr }),
			scenarioCode: String(baseGlobalParams?.scenarioCode ?? ''),
			checkLockedbj: JSON.stringify(lockPayload),
			me_code: meCodeStr,
		};

		if (baseGlobalParams?.issue_id != null && baseGlobalParams.issue_id !== '') {
			data.issue_id = String(baseGlobalParams.issue_id);
		}
		if (baseGlobalParams?.issue_short_desc != null && baseGlobalParams.issue_short_desc !== '') {
			data.issue_short_desc = String(baseGlobalParams.issue_short_desc);
		}

		const formData = new FormData();
		Object.keys(data).forEach((key) => formData.append(key, data[key]));

		return this.http.post<any>(url, formData, options);
	}
	
  	openSnackBar(message: string, panelClass: string = '') {
  	  this.gtwSnackbar.openSnackBar(message, (panelClass || '') as any, true, this.durationInSeconds);
  	}
}
